export const INCOME_ACCIDENT = {
  nickname: 'PRODUCTS.INCOME_ACCIDENT.nickname',
  icon:'income-accident'
};
